import { LogsListView } from "./LogsListView";
import BookOutlinedIcon from "@material-ui/icons/BookOutlined";

export default {
  icon: BookOutlinedIcon,
  list: LogsListView,
};
